export default function (nga, admin) {

    var cf = admin.getEntity('cognitive_functions');
    cf.listView()
        .title('{{ "Cognitive Functions" | translate }}')
        .fields([
            nga.field('name', 'text')
                .label('Name')
                .isDetailLink(true)
        ])
        .filters([
            nga.field('q', 'template')
                .label('')
                .pinned(true)
                .template('<div class="input-group"><input type="text" ng-model="value" class="form-control"></input><span class="input-group-addon"><i class="glyphicon glyphicon-search"></i></span></div>')
        ])
        .sortField('name')
        .sortDir('DESC')
        .actions(['create', 'filter'])
        .listActions(['<ma-filtered-list-button entity-name="exercises" filter="{ cognitive_function_id: entry.values.id }" size="xs"></ma-filtered-list-button>', 'edit']);
    cf.creationView()
        .fields([
            nga.field('name')
              .attributes({ placeholder: '3 chars min' })
              .validation({ required: true, minlength: 3 })
        ])
    cf.editionView()
        .title('{{ "EDIT" | translate }}')
        .fields(
            cf.creationView().fields().concat(
                nga.field('', 'template')
                    .label('')
                    .editable(false)
                    .template('<span class="pull-right"><ma-filtered-list-button entity-name="exercises" filter="{ cognitive_function_id: entry.values.id }" size="sm"></ma-filtered-list-button></span>')
            )
        )

    return cf;
}



// WEBPACK FOOTER //
// ./js/cognitive_functions/config.js